if (!customElements.get('cart-timer-component')) {
  // Global fetch interceptor to detect cart updates (add/change/update/clear)
  if (!window.__cartTimerFetchPatched) {
    window.__cartTimerFetchPatched = true;
    const originalFetch = window.fetch;
    if (typeof originalFetch === 'function') {
      window.fetch = function(...args) {
        const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
        return originalFetch.apply(this, args).then(
          (response) => {
            if (
              typeof url === 'string' &&
              (url.includes('/cart/add') ||
                url.includes('/cart/change') ||
                url.includes('/cart/update') ||
                url.includes('/cart/clear'))
            ) {
              document.dispatchEvent(new CustomEvent('cart:update'));
            }
            return response;
          },
          (error) => {
            throw error;
          }
        );
      };
    }
  }

  customElements.define('cart-timer-component', class CartTimerComponent extends HTMLElement {
    connectedCallback() {
      this.TIMER_DURATION = 30 * 60 * 1000;
      this.STORAGE_KEY = 'cartTimerTarget';
      this.timerInterval = null;
      this._isUpdating = false;

      // MutationObserver pour ré-initialiser l'affichage si le DOM interne est re-morphé par Shopify Section Rendering
      this.observer = new MutationObserver(() => {
        if (this._isUpdating) return;
        this.initCartTimer(false);
      });
      this.observer.observe(this, { childList: true, attributes: true, attributeFilter: ['style'] });

      this.initCartTimer(false);

      // Écoute des évènements de mise à jour du panier
      this.onCartUpdate = this.onCartUpdate.bind(this);
      this.onCartLinesUpdate = this.onCartLinesUpdate.bind(this);
      document.addEventListener('shopify:cart:lines-update', this.onCartLinesUpdate);
      document.addEventListener('cart:update', this.onCartUpdate);
      document.addEventListener('cart:refresh', this.onCartUpdate);
      document.addEventListener('cart:change', this.onCartUpdate);
    }

    disconnectedCallback() {
      if (this.timerInterval) clearInterval(this.timerInterval);
      if (this.observer) this.observer.disconnect();
      document.removeEventListener('shopify:cart:lines-update', this.onCartLinesUpdate);
      document.removeEventListener('cart:update', this.onCartUpdate);
      document.removeEventListener('cart:refresh', this.onCartUpdate);
      document.removeEventListener('cart:change', this.onCartUpdate);
    }

    onCartLinesUpdate(event) {
      if (event && event.promise) {
        event.promise
          .then(() => {
            this.initCartTimer(true);
          })
          .catch(() => {
            this.initCartTimer(false);
          });
      } else {
        this.onCartUpdate();
      }
    }

    onCartUpdate() {
      setTimeout(() => this.initCartTimer(true), 100);
    }

    initCartTimer(shouldReset = false) {
      const timerElement = this.querySelector('#cart-drawer-timer');
      const countdownElement = this.querySelector('#cart-timer-countdown');
      
      if (!timerElement || !countdownElement) return;

      this._isUpdating = true;
      try {
        // On s'assure que la bannière est affichée
        timerElement.style.display = 'block';

        let targetTime = parseInt(localStorage.getItem(this.STORAGE_KEY));
        const now = new Date().getTime();

        if (shouldReset || !targetTime || isNaN(targetTime) || targetTime <= now) {
          targetTime = now + this.TIMER_DURATION;
          localStorage.setItem(this.STORAGE_KEY, targetTime);
        }

        if (this.timerInterval) clearInterval(this.timerInterval);

        const updateDisplay = () => {
          const currentTime = new Date().getTime();
          let distance = targetTime - currentTime;

          if (distance < 0) {
            distance = 0;
          }

          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);
          
          const displayMinutes = minutes < 10 ? "0" + minutes : minutes;
          const displaySeconds = seconds < 10 ? "0" + seconds : seconds;
          
          const currentCountdown = this.querySelector('#cart-timer-countdown');
          if (currentCountdown) currentCountdown.innerHTML = displayMinutes + ":" + displaySeconds;
        };

        updateDisplay();
        this.timerInterval = setInterval(updateDisplay, 1000);
      } finally {
        this._isUpdating = false;
      }
    }
  });
}
